module.exports = __webpack_public_path__ + "img/w3_filter_black.82248537.png";